module.exports = __webpack_public_path__ + "media/images/shop-register-bg-old-db56bb48f4fdeff6d04ca0fd8e687965.jpg";